/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const membershipPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipPageResponseOutputItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipPageResponseOutputItemsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipPageResponseOutputItemsItemDisplayNameMax = 200;

export const membershipPageResponseOutputItemsItemStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const membershipPageResponseOutputItemsItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const membershipPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const membershipPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const membershipPageResponseOutputNextCursorOneMax = 512;

export const membershipPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const MembershipPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(membershipPageResponseOutputItemsItemIdRegExp),
      teamId: zod.uuid().regex(membershipPageResponseOutputItemsItemTeamIdRegExp),
      userId: zod.uuid().regex(membershipPageResponseOutputItemsItemUserIdRegExp),
      displayName: zod.string().min(1).max(membershipPageResponseOutputItemsItemDisplayNameMax),
      startedAt: zod.iso
        .datetime({ offset: true })
        .regex(membershipPageResponseOutputItemsItemStartedAtRegExp),
      endedAt: zod.union([
        zod.iso
          .datetime({ offset: true })
          .regex(membershipPageResponseOutputItemsItemEndedAtOneRegExp),
        zod.null(),
      ]),
      version: zod
        .int()
        .gt(membershipPageResponseOutputItemsItemVersionExclusiveMin)
        .max(membershipPageResponseOutputItemsItemVersionMax),
      teamActive: zod.boolean(),
      effective: zod.boolean(),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(membershipPageResponseOutputNextCursorOneMax)
      .regex(membershipPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type MembershipPageResponseOutput = zod.input<typeof MembershipPageResponseOutput>;
export type MembershipPageResponseOutputOutput = zod.output<typeof MembershipPageResponseOutput>;
